import { useGraphQLQuery } from '@betterment/js-runtime';

import { HomeMessageCardDocument } from './graphql/query.homeMessageCard.generated';

import { ContentCardLocation } from '../../InAppMessages/data';
import MessageCard from '../../InAppMessages/MessageCard';

type Props = {
  location: ContentCardLocation;
};

export const HomeMessageCard = (props: Props) => {
  const { location } = props;
  const { data } = useGraphQLQuery(HomeMessageCardDocument, { throwOnError: true });

  return <MessageCard isSummaryPage={true} location={location} hasNoExistingGoals={!!data?.envelopes.length} />;
};
